<strong class="label">{{ label$ | ngrxPush }}</strong>
<span *ngIf="value$ | ngrxPush as value" class="value">{{ value }}</span>
